import Resizer from "react-image-file-resizer";
import { ErrorAlert } from "./Alerts";

const maxImageSizeKb = 4000;

const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};

const getBase64ImageSizeKb = (imageBase64) => {
    const stringLength = imageBase64.length - "data:image/jpeg;base64,".length;
    const sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
    return sizeInBytes / 1000;
};

const resizeFile = (file, width, height) => {
    return new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            width,
            height,
            "JPEG",
            95,
            0,
            (uri) => {
                resolve(uri);
            },
            "base64"
        );
    });
};

const imageSizeGreater = (fileSize, size) => {
    const sizeKb = fileSize / 1000;
    return sizeKb > size;
};

const formatImage = async (e, completionHandler, width = 250, height = 250) => {
    if (
        e.target.files &&
        e.target.files[0] &&
        e.target.files[0].type.includes("image")
    ) {
        const exceededMaxSize = imageSizeGreater(
            e.target.files[0].size,
            maxImageSizeKb
        );

        try {
            if (exceededMaxSize) {
                const compressedImg = await resizeFile(
                    e.target.files[0],
                    width,
                    height
                );
                imageSizeGreater(
                    getBase64ImageSizeKb(compressedImg, maxImageSizeKb)
                )
                    ? ErrorAlert("Exceeded image size")
                    : completionHandler(compressedImg);
            } else {
                const base64 = await toBase64(e.target.files[0]);
                completionHandler(base64);
            }
        } catch (error) {
            console.log(error);
        }
    }
};

const formatImageFileBased = async (
    file,
    completionHandler,
    width = 250,
    height = 250
) => {
    if (file) {
        const exceededMaxSize = imageSizeGreater(file.size, maxImageSizeKb);

        try {
            if (exceededMaxSize) {
                const compressedImg = await resizeFile(file, width, height);
                const doubleExceed = imageSizeGreater(
                    getBase64ImageSizeKb(compressedImg, maxImageSizeKb)
                );
                doubleExceed && ErrorAlert("Exceeded image size");
                return completionHandler
                    ? completionHandler(doubleExceed ? "" : compressedImg)
                    : doubleExceed
                    ? ""
                    : compressedImg;
            } else {
                const base64 = await toBase64(file);
                return completionHandler ? completionHandler(base64) : base64;
            }
        } catch (error) {
            console.log(error);
        }
    }
};

export default {
    toBase64,
    resizeFile,
    imageSizeGreater,
    formatImage,
    formatImageFileBased,
};
